import React from 'react';

export const InWeeks = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="14" height="14" rx="7" fill="white" />
            <path
                d="M10.8252 7.375L3.3252 7.375C3.22574 7.375 3.13036 7.33549 3.06003 7.26516C2.9897 7.19484 2.9502 7.09946 2.9502 7C2.9502 6.90054 2.9897 6.80516 3.06003 6.73483C3.13036 6.66451 3.22574 6.625 3.3252 6.625L10.8252 6.625C10.9247 6.625 11.02 6.66451 11.0904 6.73483C11.1607 6.80516 11.2002 6.90054 11.2002 7C11.2002 7.09946 11.1607 7.19484 11.0904 7.26516C11.02 7.33549 10.9247 7.375 10.8252 7.375Z"
                fill="#ADA6DE"
            />
            <path
                d="M10.2943 6.99953L7.18403 3.89003C7.11361 3.81961 7.07405 3.72411 7.07405 3.62453C7.07405 3.52494 7.11361 3.42944 7.18403 3.35903C7.25444 3.28861 7.34994 3.24905 7.44953 3.24905C7.54911 3.24905 7.64461 3.28861 7.71503 3.35903L11.09 6.73403C11.1249 6.76886 11.1527 6.81024 11.1716 6.8558C11.1905 6.90136 11.2002 6.9502 11.2002 6.99953C11.2002 7.04885 11.1905 7.09769 11.1716 7.14325C11.1527 7.18881 11.1249 7.23019 11.09 7.26503L7.71503 10.64C7.64461 10.7104 7.54911 10.75 7.44953 10.75C7.34994 10.75 7.25444 10.7104 7.18403 10.64C7.11361 10.5696 7.07405 10.4741 7.07405 10.3745C7.07405 10.2749 7.11361 10.1794 7.18403 10.109L10.2943 6.99953Z"
                fill="#ADA6DE"
            />
        </svg>
    );
};
